import { Themed } from "@components/atoms/Themed"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export default defineView("single-article", (props) => {
  return (
    <Themed page theme="none" footer footerTheme={props.article?.footerTheme} className="w-full">
      <ContentBlocks blocks={props.article?.contentBlocks} />
    </Themed>
  )
})
